var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box",on:{"click":_vm.pays}},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.datas.productPic}})]),_c('div',{staticClass:"info"},[_c('div',{staticClass:"bean"},[_c('span',[_vm._v(_vm._s(_vm.datas.productName))])]),_c('div',{staticClass:"price"},[_c('span',[_vm._v("￥")]),_vm._v(_vm._s(_vm.datas.price)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }